import { render, staticRenderFns } from "./SingleImageS3.vue?vue&type=template&id=fa2d8d16"
import script from "./SingleImageS3.vue?vue&type=script&lang=js"
export * from "./SingleImageS3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa2d8d16')) {
      api.createRecord('fa2d8d16', component.options)
    } else {
      api.reload('fa2d8d16', component.options)
    }
    module.hot.accept("./SingleImageS3.vue?vue&type=template&id=fa2d8d16", function () {
      api.rerender('fa2d8d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/SingleImageS3.vue"
export default component.exports